import { useEffect } from "react";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { TrackPageViewParams } from "@datapunt/matomo-tracker-react/lib/types";

export const useTrackPageView = (value: TrackPageViewParams) => {
  const { trackPageView } = useMatomo();
  useEffect(() => {
    trackPageView(value);
  }, [value, trackPageView]);

  return;
};
